import { fetchJson, fetchResource, HTTP_VERB, ReportAPI } from "../../lib/utils"
import apiServerConstants from "../../redux/sagas/apiServerConstants"

export default class ReportRequest {

  constructor (reportAPI, isAsync) {
    this.reportAPI = reportAPI
    this.isAsync = isAsync
  }

  setReportAPI(reportAPI) {
    this.reportAPI = reportAPI
    return this
  }

  setIsAsync(isAsync) {
    this.isAsync = isAsync
    return this
  }

  setReportType(reportType) {
    this.reportType = reportType
    return this
  }

  setOutputType(outputType) {
    this.outputType = outputType
    return this
  } 

  setOfficeId(officeId) {
    this.officeId = officeId
    return this
  } 

  setLoanProductId(loanProductId) {
    this.loanProductId = loanProductId
    return this
  } 

  setStartDate(startDate) {
    this.startDate = startDate
    return this
  }

  setEndDate(endDate) {
    this.endDate = endDate
    return this
  } 

  setOnDate(onDate) {
    this.onDate = onDate
    return this
  }

  setGroupId(groupId) {
    this.groupId = groupId
    return this
  } 

  setGeneralityType(generalityType) {
    this.generalityType = generalityType
    return this
  } 

  setGlAccountId(glAccountId) {
    this.glAccountId = glAccountId
    return this
  }

  setBatchId(batchId) {
    this.batchId = batchId
    return this
  }

  setBucketId(bucketId) {
    this.bucketId = bucketId
    return this
  }

  makeCall = async (accessToken) => {

    const params = new URLSearchParams()
    params.set("officeId", this.officeId)
    params.set("outputType", this.outputType)
    params.set("async", this.isAsync)
    let reportURI = ''

    switch(this.reportAPI) {

      case ReportAPI.ACTIVE_LOAN:
        params.set("reportType", this.reportType)
        params.set("loanProductId", this.loanProductId)
        reportURI = 'loans/active'
        break

      case ReportAPI.AGING_LOAN:
        reportURI = 'agingdetail'
        break

      case ReportAPI.BALANCE_OUTSTANDING:
        params.set("onDate", this.onDate)
        reportURI = 'balanceoutstanding'
        break

      case ReportAPI.EXPECTED_PAYMENT:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        if (Number(this.groupId) > 0) {
          params.set("groupId", this.groupId)
        }
        reportURI = Number(this.groupId) > 0 ? 'expectedpaymentbydateandaffiliation' : 'expectedpaymentbydate'
        break

      case ReportAPI.PORTFOLIO_AT_RISK:
        params.set("loanProductId", this.loanProductId)
        reportURI = 'portfolioatrisk'
        break

      case ReportAPI.BRANCH_CASH_IN:
        params.set("fromDate", this.startDate)
        params.set("toDate", this.endDate)
        params.set("reportType", this.reportType)
        reportURI = 'branchcashin'
        break

      case ReportAPI.LOAN_GENERALITY:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("type", this.generalityType)
        reportURI = 'loansgenerality'
        break

      case ReportAPI.GENERAL_LEDGER:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("glAccountId", this.glAccountId)
        reportURI = 'generalledgerreport'
        break

      case ReportAPI.INCOME_STATEMENT:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        reportURI = 'incomestatement'
        break

      case ReportAPI.BALANCE_SHEET:
        params.set("endDate", this.endDate)
        reportURI = 'balancesheet'
        break

      case ReportAPI.TRIAL_BALANCE:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        reportURI = 'trialbalance'
        break

      case ReportAPI.LOAN_DISBURSED:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("groupId", this.groupId)
        reportURI = 'loansdisbursedbyaffiliation'
        break

      case ReportAPI.BATCH_PERFORMANCE:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("groupId", this.groupId)
        params.set("batchId", this.batchId)
        params.set("reportType", this.reportType)
        reportURI = 'batchperformance'
        break

      case ReportAPI.BUCKET_PERFORMANCE:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("bucketId", this.bucketId)
        params.set("reportType", this.reportType)
        reportURI = 'bucketperformance'
        break

      case ReportAPI.DEFAULTED_LOAN_DETAILS:
        params.set("startDate", this.startDate)
        params.set("endDate", this.endDate)
        params.set("groupId", this.groupId)
        reportURI = 'defaultedloansdetails'
        break

      default:
        throw new Error('Invalid API call!')
    }

    const url = `${apiServerConstants.host}/reports/${reportURI}?${params.toString()}`,
    callBack = this.isAsync ? fetchJson : fetchResource

    return callBack(HTTP_VERB.GET, url, accessToken, null)
  }
}



// WEBPACK FOOTER //
// ./src/components/Reports/ReportRequest.js